import {
  initialState,
  Actions,
  State,
  ASSIGN_LICENSE,
  ASSIGN_LICENSE_SUCCESS,
  ASSIGN_LICENSE_ERROR,
  RESET_ASSIGN_LICENSE,
} from '../../types/license/assign'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case ASSIGN_LICENSE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case ASSIGN_LICENSE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case ASSIGN_LICENSE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_ASSIGN_LICENSE:
      return initialState
    default:
      return state
  }
}

export default reducers
